module.exports = __webpack_public_path__ + "img/home-studio-3.82d3192c.png";